import {AxiosInstance} from 'axios';
import {responseHandler} from './response';
import {AuthUser, User, UserFormData} from '../../models/user';
import {SubscriptionPlan} from "../../models/subscription";
import {Region} from "../../models/region";
import {CheckoutSession} from "../../models/transaction";

export const initPayment = async (client: AxiosInstance) =>
    responseHandler<{
        subscriptions: SubscriptionPlan[]
        region: Region
    }>(client.get('/transactions/init'))

export const createCheckout = async (client: AxiosInstance, subscriptionId: string) =>
    responseHandler<CheckoutSession>(client.post('/transactions/checkout', {subscriptionId}))

